import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Tooltip,
  Col,
  Row,
  Drawer,
  Button,
  Popconfirm,
} from "antd";
import {
  PlusOutlined,
  BarsOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import FirmAccountAddForm from "../Forms/FirmAccountAddForm";
import FirmAccountUpdate from "../Forms/FirmAccountUpdate";
import { odata } from "../Filters/Helper";

const FirmAccountList = (props) => {

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [order, setOrder] = useState("");

  const [addFormVisible, setAddFormVisible] = useState(false);
  const [updateFormVisible, setUpdateFormVisible] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});

  useEffect(() => getTableData(), [order, tableDataQueryOptions,props]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = '';
    const { skip, take, filter } = tableDataQueryOptions;

    const conditions = [];

    if (props.match.params.firmId) {
      conditions.push(`firmId eq ${props.match.params.firmId}`);
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.get(
      `/FirmAccount?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const paging = (p, _, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const handleOnClickUpdate = (id) => {
    RequestHandler.get(`/FirmAccount/GetById/${id}`).then((response) => {

      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisible(true);
      }
    });
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/FirmAccount?id=${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onAddFormSuccess = () => {
    getTableData();
    setAddFormVisible(false);
  };

  const onUpdateFormSuccess = () => {
    getTableData();
    setUpdateFormVisible(false);
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      render: (text) => {
        return (
          <div style={{ width: 100 }}>
            {" "}
            <img src={text}></img>
          </div>
        );
      },
    },
    {
      title: "Proje Adı",
      dataIndex: "firmName",
      width: "10%",
      render: (text) => {
        if (!text) return;

        return (
          <Tooltip placement="topLeft" title={text}>
            {text.substring(0, 15).length < 15
              ? text.substring(0, 15) + ""
              : text.substring(0, 15) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Iban",
      dataIndex: "iban",
    },
    {
      title: "Hesap Numarası",
      dataIndex: "accountNumber",
      key: "accountNumber",
    },
    {
      title: "Güncelle",
      dataIndex: "id",
      align: "right",
      width: "10%",
      render: (data) => (
        <a
          onClick={() => {
            handleOnClickUpdate(data);
          }}
          style={{ color: "orange", fontSize: "130%" }}
        >
          <EditOutlined />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={14}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> CARİ HESAPLARI
          </p>
        </Col>
        <Col xs={24} md={12} lg={10} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => setAddFormVisible(true)}
          >
            <PlusOutlined /> Proje Hesabı Ekle
          </Button>
        </Col>
      </Row>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            rowKey="id"
            filterable={true}
            size="small"
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
          />
        </Col>
      </Row>

      <Drawer
        id="addFirmAccountDrawer"
        title="Proje Hesabı Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisible(false)}
        visible={addFormVisible}
      >
        <FirmAccountAddForm onSuccess={onAddFormSuccess} data={{ firmId: props.match.params.firmId }} />
      </Drawer>

      <Drawer
        id="updateFirmAccountDrawer"
        title="Proje Hesabı Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisible(false)}
        visible={updateFormVisible}
      >
        <FirmAccountUpdate
          data={updateFormData}
          onSuccess={onUpdateFormSuccess}
        />
      </Drawer>
    </>
  );
};

export default FirmAccountList;
